import Axios from "axios";
import { SET_INV_DELIVERY_REPORT, UNSET_INV_DELIVERY_REPORT } from "@/store/mutation-types";
import { getInvDeliveryReport } from "@/store/api";

const state = { getInvDeliveryReport: {} };

const getters = {
  getInvDeliveryReport(state) {
    return state.getInvDeliveryReport;
  },
};

const mutations = {
  [SET_INV_DELIVERY_REPORT](state, data) {
    state.getInvDeliveryReport = data;
  },
  [UNSET_INV_DELIVERY_REPORT](state) {
    state.getInvDeliveryReport = {};
  },
};

const actions = {
  getInvDeliveryReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvDeliveryReport, { params: data })
        .then(function (response) {
          commit("SET_INV_DELIVERY_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_DELIVERY_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default { state, getters, actions, mutations };
